
<template>
    <div class='row justify-center full-width q-ma-xs'>
        <div class="row  justify-end  q-pa-xs q-mt-md q-mb-md" style="width:95%; max-width:1000px;">
             <q-btn 
                color='positive' 
                label="Добавить нового"
                icon="add"
                @click='addNewExecutor'
            />
        </div>
        <div class=" row  justify-center shadow-1 q-pa-xs" style="width:95%; max-width:1000px;">
            <!-- Заголовок таблицы -->
            <div class="row full-width no-wrap justify-center text-center  bg-primary text-white q-body-1">

                <div class='col-md-1 col-lg-1 col-xl-1 col-sm-2 col-xs-2 border-right ellipsis q-pa-sm'>
                    <q-icon name='menu'/>
                   <!-- под управляющие кнопки -->
                </div>
                <div class="col-xs-4 col-sm-3 col-md-3 col-lg-2 col-xl-2 q-pa-sm border-right ellipsis-2-lines">Наименование</div>
                <div class="gt-xs col-3 q-pa-sm border-right ellipsis-2-lines">Контакт</div>
                <div class="gt-sm col-2 q-pa-sm border-right ellipsis-2-lines">Телефон</div>
                <div class="col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 q-pa-sm border-right ellipsis-2-lines">Направления</div>
                <div class="gt-md col-2 q-pa-sm ellipsis-2-lines">Комментарии</div>
            </div>
            <!-- выводим основные данные -->
            <div 
                v-for='item in executorsList' 
                :key='item.id' 
                class='row full-width no-wrap justify-center exe-line cursor-pointer q-body-2'
                v-bind:class="{ 'exe-line-dark' :  item.id % 2 == 0, 'blocked-line' : item.active==0}"
            >

                <div class="col-md-1 col-lg-1 col-xl-1 col-sm-2 col-xs-2 ellipsis border-right text-center q-pa-xs">

                    <q-btn-dropdown dense icon="menu" flat size='sm' color='primary' v-if='item.lock_at==null'>
                        <!-- dropdown content -->
                        <q-list link>
                            <q-list-header>
                                Выбор действия
                            </q-list-header>
                            <q-item-separator />

                            <q-item v-close-overlay @click.native='toggleActive(item)' size='sm'>
                                <q-item-side icon="lock" inverted color="primary"  v-if='item.active==1'/>
                                <q-item-side icon="lock_open" inverted color="primary"  v-if='item.active==0'/>
                                <q-item-main>
                                    <q-item-tile label v-if='item.active==1'>Заблокировать исполнителя</q-item-tile>
                                    <q-item-tile sublabel v-if='item.active==1'>Не предлагать в качестве исполнителя</q-item-tile>
                                    
                                    <q-item-tile label v-if='item.active==0'>Разблокировать исполнителя</q-item-tile>
                                    <q-item-tile sublabel v-if='item.active==0'>Включить в список исполнителей</q-item-tile>

                                </q-item-main>
                            </q-item>

                            <q-item v-close-overlay @click.native='editExecuter(item)' size='sm'>
                                <q-item-side icon="edit" inverted color="positive" />
                                <q-item-main>
                                    <q-item-tile label>редактировать запись</q-item-tile>
                                </q-item-main>
                            </q-item>

                            <q-item v-close-overlay @click.native='deleteExecutor(item)' size='sm'>
                                <q-item-side icon="delete" inverted color="negative" />
                                <q-item-main>
                                    <q-item-tile label>удалить запись</q-item-tile>
                                </q-item-main>
                            </q-item>

                        </q-list>
                    </q-btn-dropdown>
                    <q-icon name='lock' v-if='item.lock_at!=null' color='red-10'/>
                </div>
                <div class="col-xs-4 col-sm-3 col-md-3 col-lg-2 col-xl-2 q-pa-sm ellipsis-2-lines border-right">{{item.name}}</div>
                <div class="gt-xs col-3 q-pa-sm ellipsis-2-lines border-right">{{contact(item)}}</div>
                <div class="gt-sm col-2 q-pa-sm ellipsis-2-lines text-center border-right">{{phone(item)}}</div>
                <div class="col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 q-pa-sm ellipsis-2-lines text-center border-right">
                    <div v-for="(d, index) in directions(item)" :key=index>
                        {{d.name}}
                    </div>
                </div>
                <div class="gt-md col-2 q-pa-sm ellipsis">{{comment(item)}}</div>

            </div>
        </div>    
        <edit-dialog/>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    
    name : 'ExecutorsList',

    components : {
        editDialog : ()=>import('./executerEditDialog.vue'),
    },

    data() {
        return {

        }
    },
    created() {
        
        if (this.$store.getters.getAllDirections.length == 0) { //проверяем загрузку списка направлений
            this.$store.dispatch('getDirections');
        }

        if (this.$store.getters.allUsers.length ==0) {
            this.$store.dispatch('retrieveUsers');
        }

        if (this.$store.getters.getAllExecutors.length == 0) { // проверяем загрузку списка исполнителей
            this.$store.dispatch('getAllExecutors');
        }

    },
    computed : {

        executorsList() {
            let list = [];
            if (this.$store.getters.getAllExecutors != undefined) list = this.$store.getters.getAllExecutors;
            return list;
        },
    },
    methods : {
        addNewExecutor() {
            eventBus.$emit('openExecuterEditDialog', -1)
        },

        toggleActive(item){

            item.active = item.active == 1 ? 0:1;

            this.$store.dispatch('saveExecuter', item)
            .then()
            .catch();

        },

        directions(item) {
            if (item==undefined) return [];
            // let dirList = JSON.parse(item.directions);
            let list = [];
            let dirList = JSON.parse(item.directions);
            dirList.forEach(element => {
                let d = this.$store.getters.getDirectionById(element);
                if (d!= undefined) list.push(d);
            });
            return list;
            
        },

        contact(item) {
            if (item.options == undefined) return '';
            let opt = JSON.parse(item.options);
            return opt.contact;
        },
        
        phone(item) {
            if (item.options == undefined) return '';
            let opt = JSON.parse(item.options);
            return opt.phone;
        },
        comment(item) {
            if (item.options == undefined) return '';
            let opt = JSON.parse(item.options);
            return opt.comment;
        },

        deleteExecutor(item) {
            this.$store.dispatch('deleteExecutor', item)
            .then(()=>{})
            .catch(()=>{});
        },

        editExecuter(item) {
            this.$store.dispatch('lockExecutor', item.id)
            .then(()=>{
                eventBus.$emit('openExecuterEditDialog', item.id)
            })
            .catch((error)=>{

            });
        }
    }

}
</script>

<style lang="scss" scoped>
    .exe-line {
        background-color: rgb(241, 241, 241);
        margin-top: 1px;
        &:hover{
            background-color: rgb(195, 255, 193);
        }
    }
    .exe-line-dark {
        background-color: rgb(226, 226, 226);
        &:hover{
            background-color: rgb(195, 255, 193);
        }
    }
    .blocked-line {
        background-color: rgb(255, 160, 160);
        &:hover{
            background-color: rgb(195, 255, 193);
        }
    }
</style>
